import { autoinject } from 'aurelia-framework';
import { CellContextMenuEvent, ExcelExportParams, GetContextMenuItemsParams, ProcessCellForExportParams } from 'ag-grid-community';
import { IExcelExportParamsProvider } from '../resources/agGrid/i-excel-export-params-provider';

@autoinject
export class ExportExcelBase implements IExcelExportParamsProvider {
  excelParams: ExcelExportParams = {
    skipPinnedTop: false,
    skipPinnedBottom: false,
    allColumns: false,
    onlySelected: false,
    fileName: 'excelExport',
    sheetName: 'excelExport'
  };

  async init() { }

  async getExportToExcelParams(params: GetContextMenuItemsParams | CellContextMenuEvent) {
    await this.init()
    this.excelParams.processCellCallback = params => {
      return this[`export_${params.column.getColId()}`]?.(params)
        ?? (typeof (params.value) === 'boolean' ? (params.value ? 'Yes' : 'No') : params.value);
    };
    return this.excelParams;
  }

  getExportToExcelStyles() {
    const excelStyles = [
      // The base style, red font.

      // The cellClassStyle: background is green and font color is light green,
      // note that since this excel style it's defined after redFont
      // it will override the red font color obtained through cellClass:'red'
      {
        id: 'defaultCellClass',
        alignment: {
          horizontal: 'Right', vertical: 'Bottom'
        },
        borders: {
          borderBottom: {
            color: '#000000', lineStyle: 'Continuous', weight: 1
          },
          borderLeft: {
            color: '#000000', lineStyle: 'Continuous', weight: 1
          },
          borderRight: {
            color: '#000000', lineStyle: 'Continuous', weight: 1
          },
          borderTop: {
            color: '#000000', lineStyle: 'Continuous', weight: 1
          }
        },
        font: { color: '#b50771' },
        interior: {
          color: '#008000', pattern: 'Solid'
        }
      },
      {
        id: 'red-font',
        interior: {
          color: '#FF0000', pattern: 'Solid'
        }
      },
    ] as any;
    return excelStyles;
  }
}
